import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LoadingPanel } from 'components/shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { StyledDiv, StyledWrapper, StyledActionButtons } from './styles';
import { ToastNotification } from '../../../shared';
import FeatureFlagsContext from '../../FeatureFlagsContext';

export const ResellerForm = ({ loading, tab, children, location }) => {
  const featureFlags = React.useContext(FeatureFlagsContext);

  const [displayErrorMessage, setDisplayErrorMessage] = useState(false);
  const [displayRedirectMessage, setDisplayRedirectMessage] = useState(false);

  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const firstPage = 'accountType';

    const redirectFromDd =
      (tab === firstPage && queryParams.getAll('redirectFromDd')[0]) || false;
    setDisplayRedirectMessage(redirectFromDd);
  }, []);

  return (
    <StyledWrapper>
      <ToastNotification
        onClose={() => setDisplayErrorMessage(false)}
        open={displayErrorMessage}
        variant="alert"
        message="There was a problem with your form. Please contact a Platinum Advisor at (800) 553-2400."
      />
      <ToastNotification
        onClose={() => setDisplayRedirectMessage(false)}
        open={displayRedirectMessage}
        variant="info"
        message={
          <div>
            In order to sign you up for Direct Dispense, we must first create
            your account as a Platinum Reseller.
            <br />
            Please fill out our Reseller Agreement below. Thank you!
          </div>
        }
      />
      <StyledDiv className="main-page-section">
        {loading ? <LoadingPanel /> : children}
      </StyledDiv>
    </StyledWrapper>
  );
};
